// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    hmr       : false,
    firebase: {
        apiKey: 'AIzaSyDEGuG6t392F5wfcQD4_P-VOYMvVY7gBfo',
        authDomain: 'controlpanel-6e43b.firebaseapp.com',
        databaseURL: 'https://controlpanel-6e43b.firebaseio.com',
        projectId: 'controlpanel-6e43b',
        storageBucket: 'controlpanel-6e43b.appspot.com',
        messagingSenderId: '1060450478165'
    }      
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
